// extracted by mini-css-extract-plugin
module.exports = {"fullscreen":"invite_fullscreen__KA6Rb","modal":"invite_modal__1eZbP"};